import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { Store } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import rootReducer from './reducers';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ThunkAction = (dispatch: Dispatch, getState: GetState) => any;

let store: Store;

const customizedMiddleware = getDefaultMiddleware({
  immutableCheck: false,
  serializableCheck: false,
});

export default function configureMainStore(preloadedState?: State) {
  store = configureStore({
    preloadedState,
    reducer: rootReducer,
    middleware: customizedMiddleware,
  });

  return store;
}

export type Dispatch = typeof store.dispatch;
export type GetState = typeof store.getState;
export type State = ReturnType<Store['getState']>;
